import {
  EditorState, AtomicBlockUtils,
} from 'draft-js';
import EmbedComponent from './embed-component';

export function addEmbed(editorState, url, width, embedTitle) {
  const contentState = editorState.getCurrentContent();
  const contentStateWithEntity = contentState.createEntity(
    'EMBED',
    'IMMUTABLE',
    { src: url, width, embedTitle },
  );
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  console.log(entityKey);
  const newEditorState = AtomicBlockUtils.insertAtomicBlock(
    editorState,
    entityKey,
    ' ',
  );
  return EditorState.forceSelection(
    newEditorState,
    newEditorState.getCurrentContent().getSelectionAfter(),
  );
}

const createEmbedPlugin = (config) => {
  const blockRendererFn = (block, { getEditorState }) => {
    if (block.getType() === 'atomic') {
      const contentState = getEditorState().getCurrentContent();
      console.log(contentState.getEntity(block.getEntityAt(0)));

      const entity = block.getEntityAt(0);

      if (!entity) return null;
      const { type } = contentState.getEntity(entity);
      const { src, width } = contentState.getEntity(entity).getData();

      if (type === 'EMBED') {
        return {
          component: EmbedComponent,
          editable: false,
          props: {
            src,
            width,
          },
        };
      }
    }
    return null;
  };

  return {
    blockRendererFn,
    addEmbed,
  };
};

export default createEmbedPlugin;
